module.exports = "images/get-inspired-1.webp";